import { useEffect, useCallback, useState, useRef } from "react";
import { useNetwork, useSignTypedData } from "wagmi";
import { setNonce, setSignature } from "../../redux/user/action";
import { RECEIPT_BRIDGE_CONTRACTS, walletParams } from "../constants";
import { useDispatch, useSelector } from "react-redux";
import useWallet from "./useWalletConnect";
import useCustomToast from "./useToast";

function useSignature() {
  const [isSignIn, setIsSignIn] = useState(false);
  const { showToast } = useCustomToast();
  const { chain } = useNetwork();

  const dispatch = useDispatch();
  const { account, network } = useWallet();
  const { signature, nonce } = useSelector(({ user }) => user);
  const networkRef = useRef(network);

  const { isError, error, signTypedDataAsync } = useSignTypedData();

  useEffect(() => {
    networkRef.current = network;
  }, [network]);
  
  useEffect(() => {
    if (!!signature) {
      setIsSignIn(true);
    } else {
      setIsSignIn(false);
    }
  }, [signature]);

  const generateSignature = useCallback(async () => {
    debugger
    if (!networkRef.current) {
      return
      // return showToast(`${chain.name} is not supported`, "error");
    }

    const signData = {
      address: account,
      nonce: Number(Date.now()),
    };
    let temp = walletParams;
    temp.message = signData;
    temp.domain.chainId = chain.id;
    temp.domain.verifyingContract = RECEIPT_BRIDGE_CONTRACTS[networkRef.current];

    try {
      if (!!account) {
        const sig = await signTypedDataAsync(temp);
        dispatch(setSignature(sig));
        dispatch(setNonce(signData.nonce));
      }
    } catch (error) {
      console.log(error);
    }
  }, [account, chain, network]);

  const getAuth = {
    address: account,
    signature: signature,
    nonce: nonce,
    networkId: network,
  };

  return {
    generateSignature,
    isError,
    isSignIn,
    getAuth,
  };
}

export default useSignature;
